import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Catch-all for authenticated routes that don't match any defined path.
 *
 * Redirects typo URLs (e.g. /grain_bin/bogus, /nonexistent, or bare /)
 * to the appropriate dashboard with the account param preserved.
 * Uses beforeLoad (TanStack Router best practice) instead of a component-level
 * <Navigate> — runs before render, carries search params, no race conditions.
 */
export const Route = createFileRoute('/_auth/$')({
  beforeLoad: ({ context: { auth }, search }) => {
    // Don't redirect during session initialization — wait for AuthProvider
    // to complete token renewal and populate the URL with selection params.
    if (!auth?.ready) return;

    // Read container selection from URL search params (source of truth).
    // Route to the correct dashboard based on which container param is present.
    // Priority matches useContainerSearchParams: bin > barge > pile.
    const urlSearch = search as Record<string, string | undefined>;
    const to = urlSearch.bin
      ? '/grain_bin/dashboard'
      : urlSearch.barge
        ? '/barge/dashboard'
        : urlSearch.pile
          ? '/pile/dashboard'
          : '/grain/operations';
    throw redirect({ to, search: urlSearch, replace: true });
  },
});
